export * from './insurer-mobile-fitter-openings-page.component';
